/* The vehicle picker in the FR Header's second row.

   The homepage picker in miniature. Three rules are shared with it and with the
   results page, and if one of them changes here it must change there too:

     the data file      assets/ymm-data.json, fetched on first open, never on load
     the memory key     frd-ymm-last = {t, y, mk, mo}, so the homepage boxes show
                        whatever was chosen here and vice versa
     the search address /search?q=YEAR AND MAKE AND MODEL&options[prefix]=last
                        &view=categories, words joined with AND, which is the shape
                        the results page reads the vehicle back out of to draw the
                        badge (see frd-vehicle-art)

   Saved vehicles are this header's own: frd-garage = {list: [...], active: i}. Up
   to five, newest first. The badge beside each one is the make's badge from the
   same table the results page uses, printed into the page by frd-vehicle-badges.

   Everything runs off one element, [data-frd-ymm], and its data- attributes; the
   section passes its settings that way rather than through a global. */
(function () {
  'use strict';

  /* THE SEARCH FIELD: suggestions only once something is typed.
     Dawn's predictive search opens its results the moment the field is focused
     if it already holds words, so on a results page a tap on the field threw a
     product list over the page before a single key was pressed. The focus is
     swallowed here before Dawn sees it; typing or deleting still triggers its
     input handler and the list appears then. */
  var searchInput = document.querySelector('.frd-search__input');
  if (searchInput) {
    searchInput.addEventListener('focus', function (e) { e.stopImmediatePropagation(); }, true);
  }

  var root = document.querySelector('[data-frd-ymm]');
  if (!root) return;

  var MEM = 'frd-ymm-last';
  var GARAGE = 'frd-garage';
  var MAX = 5;

  var cfg = {
    dataUrl: root.getAttribute('data-data-url'),
    type: root.getAttribute('data-type') || 'auto',
    badgeBase: root.getAttribute('data-badge-base') || '',
    searchUrl: root.getAttribute('data-search-url') || '/search',
    title: root.getAttribute('data-title') || 'ADD A VEHICLE',
    sub: root.getAttribute('data-sub') || ''
  };

  var q = function (sel) { return root.querySelector(sel); };
  var el = {
    btn: q('[data-frd-ymm-toggle]'),
    badge: q('[data-frd-ymm-badge]'),
    title: q('[data-frd-ymm-title]'),
    moLabel: q('[data-frd-ymm-mo-label]'),   /* the model word under the square on phones; not the Model select */
    sub: q('[data-frd-ymm-sub]'),
    panel: q('[data-frd-ymm-panel]'),
    backdrop: q('[data-frd-ymm-backdrop]'),
    close: q('[data-frd-ymm-close]'),
    ptitle: q('[data-frd-ymm-ptitle]'),
    psub: q('[data-frd-ymm-psub]'),
    pick: q('[data-frd-ymm-pick]'),
    type: q('[data-frd-ymm-type]'),
    year: q('[data-frd-ymm-year]'),
    make: q('[data-frd-ymm-make]'),
    model: q('[data-frd-ymm-model]'),
    add: q('[data-frd-ymm-add]'),
    clear: q('[data-frd-ymm-clear]'),
    note: q('[data-frd-ymm-note]'),
    saved: q('[data-frd-ymm-saved]'),
    list: q('[data-frd-ymm-list]'),
    shop: q('[data-frd-ymm-shop]'),
    addNew: q('[data-frd-ymm-new]'),
    clearAll: q('[data-frd-ymm-clearall]')
  };

  var badges = {};
  try {
    var holder = document.getElementById('frdv-badges');
    if (holder) badges = JSON.parse(holder.textContent) || {};
  } catch (e) {}

  var CAR_SVG = '<svg class="frd-ymm__car" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M5.6 5.2A2.4 2.4 0 0 1 7.85 3.6h8.3a2.4 2.4 0 0 1 2.25 1.6l1.55 4.2H21a1 1 0 0 1 0 2h-.3l.3.8v6.3a1.5 1.5 0 0 1-1.5 1.5H18a1.5 1.5 0 0 1-1.5-1.5V17h-9v1.5A1.5 1.5 0 0 1 6 20H4.5A1.5 1.5 0 0 1 3 18.5v-6.3l.3-.8H3a1 1 0 0 1 0-2h1.05Zm1.57 4.2h9.66l-1.2-3.3a.4.4 0 0 0-.38-.3h-6.5a.4.4 0 0 0-.38.3ZM6 13.9a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Zm12 0a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Z"/></svg>';
  /* the header prints the empty-state icons (outline for phones, solid for desktop) in a template */
  var carTpl = document.querySelector('[data-frd-car]');
  if (carTpl && carTpl.innerHTML.trim()) CAR_SVG = carTpl.innerHTML;
  var GO_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10.5 3a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm0 2.4a5.1 5.1 0 1 0 0 10.2 5.1 5.1 0 0 0 0-10.2Zm6.05 9.85 4.1 4.1a1.2 1.2 0 0 1-1.7 1.7l-4.1-4.1Z" fill="currentColor"/></svg>';
  var TRASH_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 4h10M6.5 4V2.5h3V4M4.5 4l.6 9h5.8l.6-9M6.6 6.5v4.5M9.4 6.5v4.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ── storage ─────────────────────────────────────────────────────────── */
  /* The homepage picker keeps one vehicle PER TYPE: {v: {auto: {y, mk, mo},
     moto: {...}}, t: 'auto'}, t being the type it is showing. Older visits may
     still hold the flat {t, y, mk, mo}. Both are read; the per-type shape is
     what gets written, merged into whatever is there, so the homepage picker's
     other types are never wiped by a choice made here. */
  function readMemRaw() {
    try { return JSON.parse(localStorage.getItem(MEM) || 'null'); } catch (e) { return null; }
  }
  function readMem() {
    var m = readMemRaw();
    if (!m) return null;
    if (m.v) {
      var t = m.t && m.v[m.t] ? m.t : Object.keys(m.v)[0];
      var v = t ? m.v[t] : null;
      if (v && v.y && v.mk && v.mo) return { t: t, y: v.y, mk: v.mk, mo: v.mo };
      return null;
    }
    if (m.y && m.mk && m.mo) return { t: m.t || '', y: m.y, mk: m.mk, mo: m.mo };
    return null;
  }

  /* The homepage picker writes the memory key and knows nothing about the
     garage. So the memory is the newer of the two: whatever it holds is the
     vehicle the shopper chose last, wherever they chose it, and it goes to the
     front of the garage as the active one. Choosing here writes both, so the
     two never disagree for long. */
  function readGarage() {
    var g = null;
    try {
      g = JSON.parse(localStorage.getItem(GARAGE) || 'null');
    } catch (e) {}
    if (!g || !g.list || !g.list.length) g = { list: [], active: -1 };
    var m = readMem();
    if (m) {
      var cur = g.active >= 0 ? g.list[g.active] : null;
      if (!cur || !same(cur, m)) {
        var list = g.list.filter(function (x) { return !same(x, m); });
        list.unshift({ y: m.y, mk: m.mk, mo: m.mo, t: m.t || '' });
        if (list.length > MAX) list.length = MAX;
        g = { list: list, active: 0 };
        writeGarage(g);
      }
    }
    return g;
  }
  function writeGarage(g) {
    try { localStorage.setItem(GARAGE, JSON.stringify(g)); } catch (e) {}
  }
  function remember(v) {
    try {
      var m = readMemRaw() || {};
      if (!m.v) {
        var old = (m.y && m.mk && m.mo) ? { y: m.y, mk: m.mk, mo: m.mo } : null;
        m = { v: {}, t: m.t || '' };
        if (old) m.v[m.t] = old;
      }
      m.t = v.t || m.t || '';
      m.v[m.t] = { y: v.y, mk: v.mk, mo: v.mo };
      localStorage.setItem(MEM, JSON.stringify(m));
    } catch (e) {}
  }
  function forget() {
    try { localStorage.removeItem(MEM); localStorage.removeItem(GARAGE); } catch (e) {}
    root.setAttribute('data-keep', '');
  }

  function same(a, b) { return a.y === b.y && a.mk === b.mk && a.mo === b.mo; }
  function label(v) { return (v.y + ' ' + v.mk + ' ' + v.mo).toUpperCase(); }

  function badgeFor(make) {
    var b = badges[make];
    if (!b) {
      for (var k in badges) if (k.toLowerCase() === String(make).toLowerCase()) { b = badges[k]; break; }
    }
    return b ? cfg.badgeBase + 'frdv-' + b[0] + '.webp' : null;
  }
  function badgeHtml(make) {
    var src = badgeFor(make);
    if (!src) return CAR_SVG;
    /* a mask, not a picture: see .frd-ymm__mask in the snippet */
    /* single quotes inside the double-quoted style attribute; the URL is a CDN
       address built here from a known base and a slug, never user text */
    return '<span class="frd-ymm__mask" style="--m:url(' + "'" + src + "'" + ')" aria-hidden="true"></span>' +
           '<img class="frd-ymm__img" src="' + src + '" alt="" loading="lazy" decoding="async">';
  }

  /* ── the button ──────────────────────────────────────────────────────── */
  function paintButton() {
    var g = readGarage();
    var v = g.active >= 0 ? g.list[g.active] : null;
    if (v) {
      root.setAttribute('data-active', '');
      el.title.textContent = label(v);
      el.sub.textContent = '';
      el.sub.hidden = true;                 /* the name alone, centred */
      el.badge.innerHTML = badgeHtml(v.mk);
      /* the small word under the icon: the first word of the model only, so A5 not A5 SPORTBACK */
      if (el.moLabel) el.moLabel.textContent = String(v.mo).trim().split(/\s+/)[0];   /* case as stored; the CSS decides */
    } else {
      root.removeAttribute('data-active');
      el.title.textContent = cfg.title;
      el.sub.textContent = cfg.sub;
      el.sub.hidden = !cfg.sub;
      el.badge.innerHTML = CAR_SVG;
      if (el.moLabel) el.moLabel.textContent = '';
    }
  }

  /* ── the panel ───────────────────────────────────────────────────────── */
  function isPhone() { return window.matchMedia('(max-width: 749px)').matches; }

  function showView(which) {
    var savedView = which === 'saved';
    el.saved.hidden = !savedView;
    el.pick.hidden = savedView;
    if (el.ptitle) el.ptitle.textContent = savedView ? el.saved.querySelector('.frd-ymm__saved-head span').textContent : cfg.title;
    if (el.psub) { el.psub.textContent = savedView ? '' : cfg.sub; el.psub.hidden = savedView || !cfg.sub; }
    if (savedView) paintList();
  }

  function open() {
    if (root.hasAttribute('data-open')) return;
    root.setAttribute('data-open', '');
    el.btn.setAttribute('aria-expanded', 'true');
    el.panel.hidden = false;
    if (isPhone()) {
      var r = el.btn.getBoundingClientRect();
      root.style.setProperty('--frd-ymm-top', Math.round(r.bottom + 8) + 'px');
      el.backdrop.hidden = false;
      el.backdrop.setAttribute('data-on', '');
    }
    showView(readGarage().list.length ? 'saved' : 'pick');
    load();
    document.addEventListener('keydown', onKey);
    setTimeout(function () { document.addEventListener('click', onDocClick); }, 0);
  }
  /* the garage row being edited (its index), or null */
  var editing = null;
  function close() {
    editing = null;
    if (!root.hasAttribute('data-open')) return;
    root.removeAttribute('data-open');
    el.btn.setAttribute('aria-expanded', 'false');
    el.panel.hidden = true;
    el.backdrop.hidden = true;
    el.backdrop.removeAttribute('data-on');
    document.removeEventListener('keydown', onKey);
    document.removeEventListener('click', onDocClick);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  /* Decided from the event's own path, not from where the target is NOW: the
     bin button re-renders the list before this runs, so the clicked button is
     already out of the document and contains() would say the click came from
     outside. That was the panel closing itself on every delete. */
  function onDocClick(e) {
    var path = e.composedPath ? e.composedPath() : [];
    if (path.indexOf(root) !== -1) return;
    if (!root.contains(e.target)) close();
  }

  el.btn.addEventListener('click', function () { root.hasAttribute('data-open') ? close() : open(); });
  el.close.addEventListener('click', close);
  el.backdrop.addEventListener('click', close);

  /* ── data ────────────────────────────────────────────────────────────── */
  var raw = null, index = null, fetching = null, typeCache = {};
  /* the type bubble above Year: starts on the setting, or on whatever type the
     shopper last used, and re-cuts the year list when changed */
  var curType = cfg.type;
  if (el.type) {
    var mem0 = readMem();
    if (mem0 && mem0.t) curType = mem0.t;
    el.type.value = curType;
    if (el.type.value !== curType) curType = el.type.value || cfg.type;
    el.type.addEventListener('change', function () {
      curType = el.type.value;
      if (!raw) return;
      /* 18 Sep 2026: a year picked before the shopper noticed the wrong type
         carries over (2020 cars -> 2020 motorcycles); anything further along
         (a make picked) starts the picker over. */
      var keepYear = (el.year.value && !el.make.value) ? el.year.value : '';
      index = buildIndex(curType);
      fillYears();
      if (keepYear && index[keepYear]) el.year.value = keepYear;
      fillMakes();
    });
  }

  function typeOfModel(make, model) {
    var t = raw.makeType && raw.makeType[make];
    if (t) return t;
    var over = raw.modelType && raw.modelType[make];
    if (over && over[model]) return over[model];
    return (raw.mixedDefault && raw.mixedDefault[make]) || null;
  }

  /* Same walk as indexFor in the homepage picker. 'all' keeps every model. */
  function buildIndex(type) {
    var years = raw.years || raw;
    if (type === 'all' || !raw.years) return years;
    if (typeCache[type]) return typeCache[type];
    var out = {};
    for (var y in years) {
      var makes = years[y], keptMakes = null;
      for (var mk in makes) {
        var list = makes[mk], kept = null;
        for (var i = 0; i < list.length; i++) {
          if (typeOfModel(mk, list[i]) === type) { (kept || (kept = [])).push(list[i]); }
        }
        if (kept) (keptMakes || (keptMakes = {}))[mk] = kept;
      }
      if (keptMakes) out[y] = keptMakes;
    }
    typeCache[type] = out;
    return out;
  }

  function note(text) {
    el.note.textContent = text || '';
    el.note.hidden = !text;
  }

  function load() {
    if (index || fetching) return;
    note('Loading vehicles…');
    fetching = fetch(cfg.dataUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        raw = data;
        index = buildIndex(curType);
        note('');
        fillYears();
      })
      .catch(function () {
        fetching = null;
        note('Could not load the vehicle list. Please try again.');
      });
  }

  function opt(sel, value, text) {
    var o = document.createElement('option');
    o.value = value; o.textContent = text;
    sel.appendChild(o);
  }
  function fillYears() {
    el.year.innerHTML = '';
    opt(el.year, '', 'Year');
    Object.keys(index).sort(function (a, b) { return b - a; }).forEach(function (y) { opt(el.year, y, y); });
    el.year.disabled = false;
  }
  function fillMakes() {
    el.make.innerHTML = ''; opt(el.make, '', 'Make');
    el.model.innerHTML = ''; opt(el.model, '', 'Model');
    el.model.disabled = true;
    el.add.disabled = true;
    var y = el.year.value;
    if (!y || !index[y]) { el.make.disabled = true; return; }
    Object.keys(index[y]).sort().forEach(function (m) { opt(el.make, m, m); });
    el.make.disabled = false;
  }
  function fillModels() {
    el.model.innerHTML = ''; opt(el.model, '', 'Model');
    el.add.disabled = true;
    var y = el.year.value, m = el.make.value;
    if (!y || !m || !index[y] || !index[y][m]) { el.model.disabled = true; return; }
    index[y][m].slice().sort().forEach(function (mo) { opt(el.model, mo, mo); });
    el.model.disabled = false;
  }

  el.year.addEventListener('change', fillMakes);
  el.make.addEventListener('change', fillModels);
  el.model.addEventListener('change', function () { el.add.disabled = !el.model.value; if (el.model.value) window.frdMenuWarm(el.year.value, el.make.value, el.model.value); });

  el.clear.addEventListener('click', function () {
    el.year.value = '';
    fillMakes();
  });

  /* ── choosing ────────────────────────────────────────────────────────── */
  /* ── the menu's type tally, shared with the menu page ──────────────
     view=types pages 1-4 for a vehicle query, merged into {type: count},
     kept a day under frdmt:<q>. The menu page asks for it; the pickers
     call it early (the moment a model is chosen) so the answer is waiting
     when the menu opens. One in-flight promise per query, so a warm
     started here and the menu's own ask never run twice. */
  var tallyBusy = {};
  window.frdMenuTally = function (q) {
    var key = 'frdmt2:' + q;   /* 2: the row now carries each type's first photo (p) */
    try {
      var raw = localStorage.getItem(key);
      if (raw) {
        var row = JSON.parse(raw);
        if (row && row.d && (Date.now() - row.t) < 86400000) return Promise.resolve({ d: row.d, p: row.p || {} });
        localStorage.removeItem(key);
      }
    } catch (e) {}
    if (tallyBusy[q]) return tallyBusy[q];
    var base = '/search?q=' + encodeURIComponent(q).replace(/%20/g, '+') + '&options%5Bprefix%5D=last&view=types&page=';
    tallyBusy[q] = Promise.all([1, 2, 3, 4].map(function (pg) {
      return fetch(base + pg, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : []; })
        .catch(function () { return []; });
    })).then(function (pages) {
      var d = {}, p = {};
      pages.forEach(function (list) { (list || []).forEach(function (row) { if (row && row.n) { d[row.n] = (d[row.n] || 0) + (row.c || 0); if (row.i && !p[row.n]) p[row.n] = row.i; } }); });
      try { localStorage.setItem(key, JSON.stringify({ d: d, p: p, t: Date.now() })); } catch (e) {}
      delete tallyBusy[q];
      return { d: d, p: p };
    });
    return tallyBusy[q];
  };
  /* ── the tiles' verdicts ────────────────────────────────────────────
     For a vehicle query and the menu's tile addresses: {href: fitting
     count}. The tally above confirms most tiles with no further asking;
     a tile it cannot confirm gets its own four-page view=count on its
     filtered address (the bare search is capped at a thousand products,
     so a category's parts can sit outside the tally - proof of empty
     needs the tile's own pool). Each verdict is kept a day (frdmc:).
     Without hrefs the menu page's HTML is fetched for them, which is how
     the pickers warm the whole answer before the shopper arrives. */
  var checkBusy = {};
  window.frdMenuCheck = function (q, hrefs) {
    var ck = q + '|' + (hrefs ? 1 : 0);
    if (checkBusy[ck]) return checkBusy[ck];
    function tileHrefs() {
      if (hrefs) return Promise.resolve(hrefs);
      var u = '/search?q=' + encodeURIComponent(q).replace(/%20/g, '+') + '&options%5Bprefix%5D=last&view=categories';
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var out = [], re = /class="frdp__link" href="([^"]+)"/g, m;
        while ((m = re.exec(t))) out.push(m[1].replace(/&amp;/g, '&'));
        return out;
      });
    }
    function readCache(href) {
      try {
        var raw = localStorage.getItem('frdmc:' + href);
        if (!raw) return null;
        var row = JSON.parse(raw);
        if (row && (Date.now() - row.t) < 86400000) return { n: row.n, i: row.i || '' };
        localStorage.removeItem('frdmc:' + href);
      } catch (e) {}
      return null;
    }
    /* the count answer is "12+" or, since 18 Sep 2026, "12+|//cdn/...jpg" with the
       first fitting product's photo after the bar (page 1) */
    function countTile(href) {
      var pic = '';
      return Promise.all([1, 2, 3, 4].map(function (pg) {
        return fetch(href + '&view=count&page=' + pg, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (t) { t = t.trim(); var bar = t.indexOf('|'); if (bar > -1 && pg === 1) pic = t.slice(bar + 1); var n = parseInt(t, 10); return isNaN(n) ? 0 : n; });
      })).then(function (ns) {
        var n = ns[0] + ns[1] + ns[2] + ns[3];
        try { localStorage.setItem('frdmc:' + href, JSON.stringify({ n: n, i: pic, t: Date.now() })); } catch (e) {}
        return { n: n, i: pic };
      });
    }
    checkBusy[ck] = Promise.all([window.frdMenuTally(q), tileHrefs()]).then(function (got) {
      var types = got[0].d, pics = got[0].p || {}, list = got[1], out = {}, work = [];
      list.forEach(function (href) {
        if (href.indexOf('view=') > -1 || href.indexOf('/search?') !== 0) return;
        var n = 0, best = 0, pic = '';
        new URLSearchParams(href.slice(href.indexOf('?') + 1)).forEach(function (v, k) {
          if (k === 'filter.p.product_type' && types[v]) {
            n += types[v];
            /* the tile's photo: its biggest type's first fitting product */
            if (pics[v] && types[v] > best) { best = types[v]; pic = pics[v]; }
          }
        });
        if (n > 0) { out[href] = n; if (pic) out['pic:' + href] = pic; return; }
        var c = readCache(href);
        if (c !== null) { out[href] = c.n; if (c.i) out['pic:' + href] = c.i; return; }
        work.push(href);
      });
      /* the unconfirmed tiles, five at a time (four requests each) */
      var at = 0;
      function lane() {
        if (at >= work.length) return Promise.resolve();
        var href = work[at++];
        return countTile(href).then(function (r) { out[href] = r.n; if (r.i) out['pic:' + href] = r.i; }, function () { out[href] = -1; }).then(lane);
      }
      var lanes = [];
      for (var i = 0; i < Math.min(5, work.length); i++) lanes.push(lane());
      return Promise.all(lanes).then(function () { delete checkBusy[ck]; return out; });
    });
    return checkBusy[ck];
  };
  /* warm the whole answer from a picked vehicle, before the shopper gets there */
  window.frdMenuWarm = function (y, mk, mo) {
    var words = (y + ' ' + mk + ' ' + mo).split(/\s+/).filter(Boolean);
    if (words.length < 3) return;
    window.frdMenuCheck(words.join(' AND ')).catch(function () {});
    /* the home page's popular grid, warmed at the same moment (snippets/frd-popular, 22 Sep 2026) */
    if (window.frdPopularCompute) { try { window.frdPopularCompute(y, mk, mo); } catch (e) {} }
  };

  function goUrl(v) {
    var words = (v.y + ' ' + v.mk + ' ' + v.mo).split(/\s+/).filter(Boolean);
    var query = words.length > 1 ? words.join(' AND ') : words.join(' ');
    return cfg.searchUrl + '?q=' + encodeURIComponent(query).replace(/%20/g, '+') +
      '&options%5Bprefix%5D=last&view=categories';
  }
  function go(v) { window.location.href = goUrl(v); }
  /* trial (18 Sep 2026, Andrew): Add stays put on every page, the home page too.
     Set true-on-home back with: location.pathname === '/' */
  var ON_HOME = false;
  window.frdYmmRepaint = function () { paintButton(); if (root.hasAttribute('data-open')) paintList(); };
  function announce() {
    try { window.dispatchEvent(new CustomEvent('frd:vehicle', { detail: readGarage() })); } catch (e) {}
  }

  /* THE BUBBLE UNDER THE SEARCH BOX. With a vehicle saved, tapping into the empty search box
     shows "ALL 2018 RAM 1500 PARTS" under it, one tap to the menu for that vehicle. It goes as
     soon as a letter is typed or the box loses focus, so the search itself is untouched. */
  var allLink = document.querySelector('[data-frd-search-all]');
  if (searchInput && allLink) {
    var allText = allLink.querySelector('[data-frd-search-all-text]');
    var showAll = function () {
      var g = readGarage(), v = g.active >= 0 ? g.list[g.active] : null;
      if (!v || searchInput.value.trim()) { allLink.hidden = true; return; }
      allText.textContent = 'All ' + v.y + ' ' + v.mk + ' ' + v.mo + ' parts';
      allLink.href = goUrl(v);
      allLink.hidden = false;
    };
    /* focusin, not focus: the focus event on this box is stopped above for the theme's own reasons */
    searchInput.addEventListener('focusin', showAll);
    searchInput.addEventListener('input', showAll);
    searchInput.addEventListener('focusout', function () { setTimeout(function () { allLink.hidden = true; }, 200); });
    /* the tap lands before the blur can hide it */
    allLink.addEventListener('mousedown', function (e) { e.preventDefault(); });
    allLink.addEventListener('touchstart', function () { window.location.href = allLink.href; }, { passive: true });
  }

  el.add.addEventListener('click', function () {
    var v = { y: el.year.value, mk: el.make.value, mo: el.model.value };
    if (!v.y || !v.mk || !v.mo) return;
    v.t = raw ? (typeOfModel(v.mk, v.mo) || curType) : curType;
    var g = readGarage();
    if (editing !== null && g.list[editing]) g.list.splice(editing, 1);   /* an edit replaces the old entry */
    editing = null;
    var list = g.list.filter(function (x) { return !same(x, v); });
    list.unshift(v);
    if (list.length > MAX) list.length = MAX;
    writeGarage({ list: list, active: 0 });
    remember(v);
    paintButton();
    announce();
    if (ON_HOME) { go(v); return; }
    showView('saved');
  });

  function paintList() {
    var g = readGarage();
    el.list.innerHTML = '';
    g.list.forEach(function (v, i) {
      var li = document.createElement('li');
      li.className = 'frd-ymm__row';
      if (i === g.active) li.setAttribute('data-current', '');
      li.innerHTML =
        '<button type="button" class="frd-ymm__row-pick">' +
          '<span class="frd-ymm__row-badge">' + badgeHtml(v.mk) + '</span>' +
          '<span class="frd-ymm__row-name"></span>' +
        '</button>' +
        (i === g.active ? '<button type="button" class="frd-ymm__row-edit">Edit</button>' : '') +
        '<button type="button" class="frd-ymm__row-del" aria-label="Remove">' + TRASH_SVG + '</button>';
      li.querySelector('.frd-ymm__row-name').textContent = label(v);
      var editBtn = li.querySelector('.frd-ymm__row-edit');
      if (editBtn) editBtn.addEventListener('click', function () {
        editing = i;
        showView('pick');
        load();
        (fetching || Promise.resolve()).then(function () {
          if (!index) return;
          if (el.type && v.t && el.type.value !== v.t) {
            el.type.value = v.t;
            if (el.type.value === v.t) { curType = v.t; index = buildIndex(curType); fillYears(); }
          }
          el.year.value = v.y; fillMakes();
          el.make.value = v.mk; fillModels();
          el.model.value = v.mo;
          el.add.disabled = !el.model.value;
        });
      });
      li.querySelector('.frd-ymm__row-pick').addEventListener('click', function () {
        var g2 = readGarage();
        g2.active = i;
        writeGarage(g2);
        remember(v);
        paintButton();
        paintList();
        announce();
      });
      li.querySelector('.frd-ymm__row-del').addEventListener('click', function () {
        var g2 = readGarage();
        g2.list.splice(i, 1);
        if (!g2.list.length) { forget(); paintButton(); showView('pick'); return; }
        if (g2.active >= g2.list.length) g2.active = 0;
        if (g2.active === i || g2.active < 0) g2.active = 0;
        writeGarage(g2);
        remember(g2.list[g2.active]);
        paintButton();
        paintList();
        announce();
      });
      el.list.appendChild(li);
    });
    /* the one way into the menu from the garage: the selected vehicle's parts */
    if (el.shop) {
      var ga = readGarage(), cur = ga.active >= 0 ? ga.list[ga.active] : null;
      el.shop.hidden = !cur;
      /* the model's first word only: "Shop all BRZ parts", "Shop all 430i parts" */
      if (cur) el.shop.textContent = 'Shop all ' + String(cur.mo).trim().split(/\s+/)[0] + ' parts';
    }
  }
  if (el.shop) el.shop.addEventListener('click', function () {
    var ga = readGarage(), cur = ga.active >= 0 ? ga.list[ga.active] : null;
    if (cur) go(cur);
  });

  el.addNew.addEventListener('click', function () {
    editing = null;
    showView('pick');
    el.year.value = '';
    fillMakes();
    load();
  });
  if (el.clearAll) el.clearAll.addEventListener('click', function () {
    forget();
    paintButton();
    showView('pick');
    if (index) { el.year.value = ''; fillMakes(); }
  });

  paintButton();
})();
